export default __webpack_public_path__ + "static/media/template5.083ccae5.png";